import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Form,
	Button,
	Input,
	Checkbox,
} from 'antd'
import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	getQuery,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'redirectUrl':'',
			'siteUrl':'',
			'info':{},
			'rules':{
				'user_name':[
					{
						required: true,
						message: '请输入手机号',
					},
				],
				'password':[
					{
						required: true,
						message: '请输入密码',
					},
				],
			},
		};
	}
	
	componentDidMount()
	{
		global.setRootState({
			'isLogin':true,
		});
		
		let loginForm = CommonValue.get('login_form');
		if(loginForm)
		{
			this.mainForm.setFieldsValue(loginForm);
		}
		let query = getQuery();
		if(query.redirect)
			this.state.redirectUrl = '#'+query.redirect;
		if(query.back)
			this.state.redirectUrl = query.back;
		
		let siteUrl = CommonValue.get('site_url');
		this.setState({
			'siteUrl':siteUrl,
		});
		
		let url = pcUrl('index','userInfo');
		httpPost(url)
			.then(data=>{
				if(data['user_id'] && +data['user_id'])
				{
					this._login(data);
				}
			});
		
		document.title = '登录 - ' + CommonValue.get('site_name');
	}
	
	submit(info)
	{
		let url = pcUrl('index','login');
		let param = info;
		
		httpPost(url,param)
			.then(data=>{
				if(info.remember)
					CommonValue.set('login_form',info);
				
				this._login(data);
			});
	}
	
	_login(data)
	{
		CommonValue.set('user_info',data);
		global.setRootState({
			'userInfo':data,
		});
		//window.location.href = ngUrl('user');
		window.location.href = this.state.redirectUrl || ngUrl('user');
	}
	
	render()
	{
		return (
			<div className="login-body">
				<div className="body">
					<div className="new-login-form">
						<h3> 欢迎登录 </h3>
						<Form
							onFinish={e=>this.submit(e)}
							labelCol={{ span:0 }}
							wrapperCol={{ span:24 }}
							ref={e=>this.mainForm = e}>
							<Form.Item name="user_name" shouldUpdate label="" rules={this.state.rules['user_name']}>
								<Input />
							</Form.Item>
							<Form.Item name="password" label="" rules={this.state.rules['password']}>
								<Input.Password />
							</Form.Item>
							<Form.Item name="remember" hidden></Form.Item>
							<div style={{'marginBottom':'1em'}}>
								<label>
									<Form.Item noStyle shouldUpdate={(old,cur)=>cur.user_name != old.user_name}>
										{()=>(
										<Checkbox checked={this.mainForm && this.mainForm.getFieldValue('remember')} onChange={e=>{this.mainForm.setFieldsValue({'remember':e.target.checked?1:0});}}>记住密码</Checkbox>
										)}
									</Form.Item>
								</label>
							</div>
							<div style={{'marginBottom':'1em'}}>
								<Button style={{'width':'100%'}} type="primary" htmlType="submit">确认</Button>
							</div>
							<div>
								<a href={ngUrl('findPassword')} className="float-right">忘记密码</a>
								<a href={ngUrl('register')}>注册</a>
							</div>
						</Form>
					</div>
				</div>
			</div>
		);
	}
}

